export const ApplicantRegistrationTranslations = {
    en: {
        registration: {
            "selectGender": "Select Gender",
            "genderMale": "Male",
            "genderFemale": "Female",
            "genderOther": " Transgender",
            "gender": "Gender",
            "title": "Create Your Account",
            "login": "Login",
            "register": "Register",
            "closeForm": "Close registration form",
            "showInstructions": "Show instructions",
            "personalInfo": "Personal Information",
            "addressInfo": "Address Information",
            "security": "Security",
            "firstName": "First Name",
            "firstNamePlaceholder": "First name",
            "middleName": "Middle Name",
            "middleNamePlaceholder": "Middle name",
            "lastName": "Last Name",
            "lastNamePlaceholder": "Last name",
            "email": "Email",
            "emailPlaceholder": "your@email.com",
            "mobile": "Mobile Number",
            "mobilePlaceholder": "10-digit number",
            "address": "Address",
            "addressPlaceholder": "Full address",
            "division": "Division",
            "selectDivision": "Select Division",
            "district": "District",
            "selectDistrict": "Select District",
            "taluka": "Taluka",
            "selectTaluka": "Select Taluka",
            "village": "Village",
            "villagePlaceholder": "Enter village name",
            "password": "Password",
            "passwordPlaceholder": "At least 8 characters",
            "passwordRequirements": "Include uppercase, lowercase, number, and special character",
            "confirmPassword": "Confirm Password",
            "confirmPasswordPlaceholder": "Re-enter password",
            "registerButton": "Register",
            "registering": "Registering...",
            "resetButton": "Reset",
            "haveAccount": "Already have an account?",
            "signIn": "Log in",
            "success": "Success!",
            "error": "Error",
            "proceedToLogin": "Proceed to Login",
            "tryAgain": "Try Again",
            "successMessage": "Registration successful! You can now login.",
            "instructionsTitle": "General Instructions",
            "instruction1": "Since all the applications will be screened on the basis of data submitted by the applicant, it is advised to submit correct information.",
            "instruction2": "If at any stage during the process, it is found that the applicant has furnished incomplete or false or wrong information, their application will be rejected.",
            "instruction3": "You must possess a valid e-mail ID for applying online as the same will be used for future correspondence with you. Please create a new email ID, if you do not have one, prior to filling up an online application.",
            "instruction4": "In case, an applicant has previously applied online for any application for availing any online service (part plan or zone certificate), in order to apply for a fresh application for availing any service, the applicant is required to apply online using a same USER NAME and E-MAIL ID (rest all details can be the same). Applicants need not register again.",
            "okButton": "OK",
            "closeInstructions": "Close instructions",
            "errors": {
                "genderRequired": "Gender is Required",
                "firstNameRequired": "First name is required",
                "lastNameRequired": "Last name is required",
                "emailRequired": "Email is required",
                "validEmail": "Please enter a valid email",
                "mobileRequired": "Mobile number is required",
                "mobileDigits": "Mobile must be 10 digits",
                "addressRequired": "Address is required",
                "selectDivision": "Please select division",
                "selectDistrict": "Please select district",
                "selectTaluka": "Please select taluka",
                "enterVillage": "Please enter village",
                "passwordRequired": "Password is required",
                "passwordLength": "Password must be at least 8 characters",
                "passwordWeak": "Password is too weak",
                "confirmPassword": "Please confirm password",
                "passwordMismatch": "Passwords do not match",
                "registrationFailed": "Registration failed. Please try again.",
                "registrationIncomplete": "Registration could not be completed."
            }
        }

    },
    mr: {

        registration: {
            "selectGender": "लिंग निवडा",
            "genderMale": "पुरुष",
            "genderFemale": "महिला",
            "genderOther": "इतर",
            "gender": "लिंग",
            "title": "तुमचे खाते तयार करा",
            "login": "लॉगिन",
            "register": "नोंदणी",
            "closeForm": "नोंदणी फॉर्म बंद करा",
            "showInstructions": "सूचना दाखवा",
            "personalInfo": "वैयक्तिक माहिती",
            "addressInfo": "पत्ता माहिती",
            "security": "सुरक्षा",
            "firstName": "पहिले नाव",
            "firstNamePlaceholder": "पहिले नाव",
            "middleName": "मधले नाव",
            "middleNamePlaceholder": "मधले नाव",
            "lastName": "आडनाव",
            "lastNamePlaceholder": "आडनाव",
            "email": "ईमेल",
            "emailPlaceholder": "तुमचा@ईमेल.कॉम",
            "mobile": "मोबाइल",
            "mobilePlaceholder": "10-अंकी क्रमांक",
            "address": "पत्ता",
            "addressPlaceholder": "पूर्ण पत्ता",
            "division": "विभाग",
            "selectDivision": "विभाग निवडा",
            "district": "जिल्हा",
            "selectDistrict": "जिल्हा निवडा",
            "taluka": "तालुका",
            "selectTaluka": "तालुका निवडा",
            "village": "गाव",
            "villagePlaceholder": "गावाचे नाव प्रविष्ट करा",
            "password": "पासवर्ड",
            "passwordPlaceholder": "किमान 8 वर्ण",
            "passwordRequirements": "मोठ्या अक्षर, लहान अक्षर, संख्या आणि विशेष वर्ण समाविष्ट करा",
            "confirmPassword": "पासवर्ड पुष्टी करा",
            "confirmPasswordPlaceholder": "पासवर्ड पुन्हा प्रविष्ट करा",
            "registerButton": "नोंदणी करा",
            "registering": "नोंदणी करत आहे...",
            "resetButton": "रीसेट",
            "haveAccount": "आधीपासून खाते आहे?",
            "signIn": "साइन इन",
            "success": "यशस्वी!",
            "error": "त्रुटी",
            "proceedToLogin": "लॉगिनवर जा",
            "tryAgain": "पुन्हा प्रयत्न करा",
            "successMessage": "नोंदणी यशस्वी! आता तुम्ही लॉगिन करू शकता.",
            "instructionsTitle": "सामान्य सूचना",
            "instruction1": "अर्जदाराने सादर केलेल्या डेटाच्या आधारे सर्व अर्ज तपासले जात असल्याने, योग्य माहिती सादर करण्याचा सल्ला दिला जातो.",
            "instruction2": "जर प्रक्रियेदरम्यान कोणत्याही टप्प्यावर असे आढळले की अर्जदाराने अपूर्ण किंवा खोटी किंवा चुकीची माहिती सादर केली आहे, तर त्यांचा अर्ज नाकारला जाईल.",
            "instruction3": "ऑनलाइन अर्ज करण्यासाठी तुमच्याकडे एक वैध ई-मेल आयडी असणे आवश्यक आहे कारण तुमच्याशी पुढील पत्रव्यवहारासाठी तेच वापरले जाईल. ऑनलाइन अर्ज भरण्यापूर्वी, तुमच्याकडे नसल्यास, कृपया एक नवीन ईमेल आयडी तयार करा.",
            "instruction4": "जर अर्जदाराने आधी कोणत्याही ऑनलाइन सेवेसाठी (भाग योजना किंवा झोन प्रमाणपत्र) ऑनलाइन अर्ज केला असेल, तर कोणत्याही सेवेचा लाभ घेण्यासाठी नवीन अर्ज करण्यासाठी, अर्जदाराला समान वापरकर्तानाव आणि ई-मेल आयडी वापरून ऑनलाइन अर्ज करणे आवश्यक आहे (इतर सर्व तपशील समान असू शकतात). अर्जदारांना पुन्हा नोंदणी करण्याची आवश्यकता नाही.",
            "okButton": "ठीक आहे",
            "closeInstructions": "सूचना बंद करा",
            "errors": {
                "genderRequired": "लिंग आवश्यक आहे",
                "firstNameRequired": "पहिले नाव आवश्यक आहे",
                "lastNameRequired": "आडनाव आवश्यक आहे",
                "emailRequired": "ईमेल आवश्यक आहे",
                "validEmail": "कृपया वैध ईमेल प्रविष्ट करा",
                "mobileRequired": "मोबाइल नंबर आवश्यक आहे",
                "mobileDigits": "मोबाइल 10 अंकी असावा",
                "addressRequired": "पत्ता आवश्यक आहे",
                "selectDivision": "कृपया विभाग निवडा",
                "selectDistrict": "कृपया जिल्हा निवडा",
                "selectTaluka": "कृपया तालुका निवडा",
                "enterVillage": "कृपया गावाचे नाव प्रविष्ट करा",
                "passwordRequired": "पासवर्ड आवश्यक आहे",
                "passwordLength": "पासवर्ड किमान 8 वर्णांचा असावा",
                "passwordWeak": "पासवर्ड खूप कमकुवत आहे",
                "confirmPassword": "कृपया पासवर्ड पुष्टी करा",
                "passwordMismatch": "पासवर्ड जुळत नाहीत",
                "registrationFailed": "नोंदणी अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
                "registrationIncomplete": "नोंदणी पूर्ण केली जाऊ शकली नाही."
            }
        },
    }
};
